/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-setting-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalHeader = `${prefix}.modalHeader`;
export const replicationModeLabel = `${prefix}.replicationModeLabel`;

export const ENGLISH = {
    [modalHeader]: 'Edit GSLB Setting',
    [replicationModeLabel]: 'Replication Mode',
};
